const isJingJiang = location.href.startsWith("https://jjhqm.")
export default {
  dev: {
    VUE_APP_APICASBASEURL: isJingJiang ? "https://jjhqm-login-fat.vocust.com" : "https://login-fat.vocust.com",
    VUE_APP_APISURVEYBASEURL: "https://xm-fat.cemsmart.com/prod-api"
  },
  fat: {
    VUE_APP_APICASBASEURL: isJingJiang ? "https://jjhqm-login-fat.vocust.com" : "https://login-fat.vocust.com",
    VUE_APP_APISURVEYBASEURL: "https://xm-fat.cemsmart.com/prod-api"
  },
  fort: {
    VUE_APP_APICASBASEURL: "https://login.vocust.com",
    VUE_APP_APISURVEYBASEURL: "https://qq2.vocust.com/prod-api"
  },
  uat: {
    VUE_APP_APICASBASEURL: "https://login-fat.vocust.com",
    VUE_APP_APISURVEYBASEURL: "https://xm-uat.cemsmart.com/prod-api"
  },
  prod: {
    VUE_APP_APICASBASEURL: isJingJiang ? "https://jjhqm-login.vocust.com" : "https://login.vocust.com",
    VUE_APP_APISURVEYBASEURL: "https://survey.vocust.com/prod-api"
  }
}
